export class SubfamiliaProdutoEntity {
  ativado = true;
  descricao = null;

  constructor(subfamiliaProduto) {
    if (subfamiliaProduto.ativado === false) {
      this.ativado = false;
    }
    this.descricao = subfamiliaProduto.descricao;
  }
}
